export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SMTPSettings.json?hash=c26b0495b7f4fb7563e2277d0032ca9b";